import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { AssociateRegistrationStatusEnum, TimeZoneEnum } from "../../data/enums";

export namespace AssociateRegistrationValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.array(v.picklist(AssociateRegistrationStatusEnum.values))),
            }),
        }),
    );

    export const Signup = defineValidation(
        v.object({
            name: baseVals.string(),
            phone: baseVals.phone(),
            address: baseVals.string(),
            location: baseVals.coordinate(),
            identityNumber: baseVals.string(),
            identityCardFile: baseVals.string(),
        }),
    );

    export const Finalize = defineValidation(
        v.object({
            username: baseVals.username(),
            password: baseVals.password(),
            timeZone: v.picklist(TimeZoneEnum.values),
            billingDay: baseVals.intRange(1, 28, "Tanggal Tagihan Sistem"),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.phone()),
            address: v.exactOptional(baseVals.string()),
            location: v.exactOptional(baseVals.coordinate()),
            identityNumber: v.exactOptional(baseVals.string()),
        }),
    );
}
